import React from 'react'
import {styled} from '@mui/material'
import CircularProgress, {
  CircularProgressProps,
} from '@mui/material/CircularProgress'
import spinnerStyles from './spinner.styles'

interface ApSpinnerAtomProps extends CircularProgressProps {
  ap_type: 'app_spinner'
}

const apAtomName = {ap_atom_name: 'apSpinnerAtom'}

const StyledSpinner = styled(CircularProgress)`
  ${spinnerStyles}
`

const SpinnerAtom: React.FC<ApSpinnerAtomProps> = function (props) {
  return <StyledSpinner {...apAtomName} {...props} />
}

export default SpinnerAtom
